import { DataGridContainer } from '../styles'
import { CourtesyTicketsProps } from '../../../../hooks/producer-pdv'
import { DashboardTicketSelector } from 'bd-web-components'
import { FlowButtonControl } from '../../../../components/FlowButtonControl'
import { CourtesyRequestInitialProps } from '../../../../utils/courtesy-request-utils'
import { FormikProps } from 'formik'

interface TicketSelectorComponentProps {
  tickets: CourtesyTicketsProps[] | null
  handleButtonClick: () => void
  useFormikProps: FormikProps<CourtesyRequestInitialProps>
  name: keyof CourtesyRequestInitialProps
  rollBack: () => void
}

export const TicketSelector = ({
  tickets,
  name,
  useFormikProps,
  rollBack,
  handleButtonClick,
}: TicketSelectorComponentProps) => {
  const hasTicket = useFormikProps.values[name] !== ''
  return (
    <>
      <DataGridContainer>
        {tickets !== null &&
          tickets.map((ticket: CourtesyTicketsProps) => {
            const active = useFormikProps.values[name] === ticket.ticket_id
            return (
              <div style={{ marginBottom: '10px' }}>
                <DashboardTicketSelector
                  key={ticket.ticket_id}
                  title={ticket.ticket_name}
                  event={ticket.ticket_lote}
                  active={active}
                  onClick={() => {
                    useFormikProps.setFieldValue(name, ticket.ticket_id)
                  }}
                />
              </div>
            )
          })}
      </DataGridContainer>
      <FlowButtonControl
        rollback={rollBack}
        flowControl={hasTicket}
        action={handleButtonClick}
      />
    </>
  )
}
